import { param, segment } from './endpoints-builder.js';
export { param, segment };
const BASE_API_URL_V1 = `${window.location.protocol}//${window.location.host}/API`;
const BASE_API_URL_V2 = `${window.location.protocol}//${window.location.host}/XAPI/v2`;
export const BASE_WS_URL = `${window.location.protocol === 'https:' ? 'wss:' : 'ws:'}//${window.location.host}/ws`;
export const apiV1 = segment(BASE_API_URL_V1, {
    project: segment('Project', {
        id: param({
            files: segment('Files', {
                // NOTE: Use API v1 to enable saving from outdated frontend.
                currentTrsx: segment('CurrentTrsx'),
                originalTrsx: segment('OriginalTrsx'),
            }),
        }),
        uploadMediaFile: segment('UploadMediaFile'),
    }),
    admin: segment('Admin', {
        user: segment('User'), // bug in backend v2
    }),
});
export const apiV2 = segment(`${BASE_API_URL_V2}`, {
    admin: segment('Admin', {
        information: segment('Information', {
            transcriptionProfiles: segment('TranscriptionProfiles'),
        }),
        teams: segment('Teams', {
            id: param({
                credit: segment('Credit', {
                    add: segment('Add'),
                    subtract: segment('Subtract'),
                }),
                exportMembers: segment('ExportMembers'),
                setManagementGroup: segment('SetManagementGroup'),
                voiceprintModels: segment('VoiceprintModels'),
                abandonProjectsIn: segment('AbandonProjectsIn'),
                storageStatistics: segment('StorageStatistics'),
                transcribedPerPeriod: segment('TranscribedPerPeriod'),
                members: segment('Members'),
                exportTemplates: segment('ExportTemplates'),
            }),
        }),
        users: segment('Users', {
            search: segment('Search'),
            id: param({
                storageStatistics: segment('StorageStatistics'),
                abandonProjectsIn: segment('AbandonProjectsIn'),
                queueTranscriptionLimit: segment('QueueTranscriptionLimit'),
                directTranscriptionLimit: segment('DirectTranscriptionLimit'),
                isDeletable: segment('IsDeletable'),
                claimSet: segment('ClaimSet', {
                    add: segment('Add'),
                    remove: segment('Remove'),
                    reset: segment('Reset'),
                }),
            }),
        }),
        managementGroups: segment('ManagementGroups', {
            groupId: param(),
        }),
    }),
    externalLogin: segment('ExternalLogin'),
    login: segment('Login'),
    logout: segment('Logout'),
    registerAndLogin: segment('RegisterAndLogin'),
    speakers: segment('Speakers', {
        id: param(),
        roles: segment('Roles', {
            id: param(),
            suggest: segment('Suggest'),
        }),
    }),
    apps: segment('Apps', {}),
    log: segment('Log'),
    orders: segment('Orders', {
        pricingSettings: segment('PricingSettings'),
        stripePricingSettings: segment('StripePricingSettings'),
        stripe: segment('Stripe'),
        checkout: segment('Checkout'),
    }),
    shop: segment('Shop', {
        getStripeProducts: segment('GetStripeProducts'),
    }),
    passwordSettings: segment('PasswordSettings'),
    projects: segment('Projects', {
        id: param({
            size: segment('Size'),
            export: segment('Export', {
                subtitles: segment('Subtitles', {
                    fromLabeled: segment('FromLabeled'),
                    labelTrsx: segment('LabelTrsx'),
                }),
            }),
            trash: segment('Trash', {
                trash: segment('Trash'),
            }),
            messageCache: segment('MessageCache'),
            files: segment('Files', {
                mediaFile: segment('MediaFile'),
                mpdManifest: segment('MpdManifest'),
                scenes: segment('Scenes'),
                // NOTE: Use API v1 to enable saving from outdated frontend.
                currentTrsx: segment('CurrentTrsx'),
                originalTrsx: segment('OriginalTrsx'),
            }),
            lowQualityAudio: segment('LowQualityAudio'),
            lastError: segment('LastError'),
            metadata: segment('Metadata', {
                tags: segment('Tags'),
            }),
            sharings: segment('Sharings'),
            transcribe: segment('Transcribe'),
            enqueue: segment('Enqueue'),
            name: segment('Name'),
        }),
        allTags: segment('AllTags'),
        createDemoProjects: segment('CreateDemoProjects'),
        fullTextSearch: segment('FullTextSearch'),
        search: segment('Search'),
        queue: segment('Queue'),
        export: segment('Export', {
            list: segment('List'),
            fullTextSearchList: segment('ListWithFullTextSearch'),
        }),
        // NOTE: Not yet supported.
        // uploadMediaFile: segment('UploadMediaFile'),
    }),
    providers: segment('Providers'),
    resetPasswordRequest: segment('ResetPasswordRequest'),
    system: segment('System', {
        announcements: segment('Announcements', {
            id: param(),
        }),
        publicServices: segment('PublicServices'),
    }),
    currentTeam: segment('CurrentTeam', {
        transcriptionPerPeriod: segment('TranscribedPerPeriod'),
        memberTranscriptionLogExport: segment('MemberTranscriptionLogExport'),
        settings: segment('Settings'),
        exportTemplates: segment('ExportTemplates'),
        abandonProjectsIn: segment('AbandonProjectsIn'),
        members: segment('Members', {
            id: param({
                transcriptionLog: segment('TranscriptionLog', {
                    export: segment('Export'),
                }),
            }),
        }),
        lexicon: segment('Lexicon'),
        expiringCredit: segment('ExpiringCredit'),
        plan: segment('Plan')
    }),
    currentUser: segment('CurrentUser', {
        setTestClock: segment('SetTestClock'),
        abbreviations: segment('Abbreviations', {
            batch: segment('Batch'),
        }),
        activateAccount: segment('ActivateAccount'),
        commercialCommunicationConsent: segment('CommercialCommunicationConsent'),
        dataProtectionConsent: segment('DataProtectionConsent'),
        paymentInfo: segment('PaymentInfo', {
            countryList: segment('CountryList'),
        }),
        resetPassword: segment('ResetPassword'),
        sendActivationEmail: segment('SendActivationEmail'),
        setLanguage: segment('SetLanguage'),
        transcriptionLog: segment('TranscriptionLog'),
        aggregatedTranscriptionLog: segment('AggregatedTranscriptionLog'),
        transcriptionProfiles: segment('TranscriptionProfiles'),
        changePassword: segment('ChangePassword'),
        settings: segment('Settings'),
        stripeCustomerPortal: segment('StripeCustomerPortal'),
    }),
    apiToken: segment('ApiToken'),
});
export const wsV1 = segment(BASE_WS_URL, {
    liveUpdate: segment('LiveUpdate'),
    speakerSuggestion: segment('SpeakerSuggestion'),
    upload: segment('Upload'),
});
export const xapiV1 = segment(`${window.location.protocol}//${window.location.host}/XAPI`, {
    system: segment('System', {
        // NOTE: this endpoint is not yet implemented in api v2
        apa: segment('APA'),
    }),
});
